import Vue from 'vue'

import Cookies from 'js-cookie'

import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import Element from 'element-ui'
import './styles/element-variables.scss'

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'

import './icons' // icon
import './permission' // permission control
import './utils/error-log' // error log
import enterNumber from '@/directive/enterNumber'
import elHeightAdaptiveTable from '@/directive/el-table'
import saveScrollPosition from '@/directive/save-scroll-position'
import highlightNegativeNumber from '@/directive/highlight-negative-number'
import * as filters from './filters' // global filters

import mixin from '@/mixins/global';// global mixin
import Print from 'vue-print-nb'

Vue.mixin(mixin);
Vue.use(enterNumber)
Vue.use(elHeightAdaptiveTable)
Vue.use(saveScrollPosition)
Vue.use(highlightNegativeNumber)
Vue.use(Element, {
  zIndex: 1000,
  size: Cookies.get('size') || 'medium' // set element-ui default size Cookies.get('size')
})
Vue.use(Print);

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  created () {
    // 埋点
    var _script = document.createElement('script');
    _script.type = 'text/javascript';
    _script.src = '//webtrack.pospal.cn/sdk.bundle.js';
    _script.id = '_pospal_track_sdk'
    _script.setAttribute('autoinit', true)// 自动 init
    _script.setAttribute('bid', 'finance')
    // 以下可选[公共属性]
    // _script.setAttribute('userId',1)
    // _script.setAttribute('channel','pospal')
    // _script.setAttribute('subChannel','subPospal')
    // _script.setAttribute('userProp','{"d":12}')//JSON 格式字符串
    document.head.appendChild(_script);
  },
  render: h => h(App)
})
